const RAWMap = {
  'review-passed': '审阅通过',
  'review-rejected': '审阅拒绝',
  'review-closed': '审阅关闭',
  'review-processing': '审阅中',
  'review-returned': '已退回',
  'collection-expired': '已截止',
  'collection-valid': '已失效',
  'collection-pending': '进行中',
  'workflow-processing': '审批中',
  'workflow-rejected': '审批拒绝',
  'workflow-passed': '审批通过',
  'workflow-closed': '审批关闭',
  'workflow-returned': '已退回'
}

export const getReviewBadge = (type, status) => {
  let icon, text

  switch (status) {
    case 'passed':
      icon = require('@/assets/embedAppPageImg/green.svg')
      break
    case 'rejected':
    case 'returned':
      icon = require('@/assets/embedAppPageImg/red.svg')
      break
    case 'closed':
    case 'invalid':
      icon = require('@/assets/embedAppPageImg/gray.svg')
      break
    case 'processing':
      icon = require('@/assets/embedAppPageImg/orange.svg')
      break
  }

  text = RAWMap[type + '-' + status]
  return [icon, text]
}
